// Body of the unified sales-channel order-lookup page (step 1): the "Check
// Your Order Status" heading, the lookup form (order number + delivery ZIP)
// with the order-number help popup island, and the decorative account image.
// The form is the account-form field tree (build_account_form_props +
// FormFields, the same oscar/partials/form_field.html contract), so an invalid
// POST re-renders its errors and a valid POST redirects to the status page.
import { Immutable } from "immer";
import React from "react";
import { FormFields } from "tsi-common-react/src/apps/customer-account/FormFields/index";
import { FORM_FIELD_SUBMIT_CLASS_NAME } from "tsi-common-react/src/forms/classNames";
import { useStaticURL } from "tsi-common-react/src/utils/urls";

import { templates } from "@reactivated";

import { CSRFToken } from "@reactivated/forms";

import { Template as OrderNumberPopup } from "../../templates/OrderNumberPopupTemplate";

type IProps = Immutable<templates.UnifiedOrderLookupDocumentTemplate>;

export const UnifiedOrderLookupBody = (props: IProps): React.JSX.Element => {
    const staticURL = useStaticURL();
    return (
        <div className="l-capped-width">
            <div className="account-page-title">
                <h1>{props.heading}</h1>
            </div>

            <section className="account-page-container">
                <div>
                    <div>
                        <form
                            id="lookup-orders-by-email-form"
                            className="unified-order-status-form"
                            action="."
                            method="post"
                        >
                            <p className="unified-order-copy">
                                {props.intro_copy}
                            </p>
                            <CSRFToken />
                            <div className="unified-order-popup-wrapper">
                                <OrderNumberPopup
                                    {...props.order_number_popup}
                                />
                            </div>
                            <FormFields
                                fields={props.fields}
                                field_labels={props.field_labels}
                                field_errors={props.field_errors}
                                non_field_errors={props.non_field_errors}
                                showRequiredLegend
                            />
                            <div className={FORM_FIELD_SUBMIT_CLASS_NAME}>
                                <input
                                    type="submit"
                                    className="button button--full-width"
                                    value={props.submit_text}
                                />
                            </div>
                        </form>
                    </div>
                </div>
                <div>
                    <img
                        src={`${staticURL}${props.image_url}`}
                        alt={props.image_alt}
                        className="unified-order-img"
                    />
                </div>
            </section>
        </div>
    );
};
